import * as _MBOCDC from '@mbo/cdc'
import { computed, ref, unref } from 'vue'
import { useEventListener } from '@vueuse/core'

const init = ref(false)
const xprops = ref()
const context = computed(() => ({
  ...xprops.value?.context,
  addonsPassword: xprops.value?.addonsPassword,
  addonsUsername: xprops.value?.addonsUsername,
  isConnectedToAddonsPS17: xprops.value?.isConnectedToAddonsPS17,
}))

const onCloseQueue = ref<(() => void)[]>([])

export default () => {
  if (_MBOCDC && !init.value) {
    xprops.value = (window as any).xprops

    if (xprops.value) {
      useEventListener(window, 'message', (event) => {
        if (event?.data?.uid === xprops.value.uid) {
          if (event?.data?.name === 'onClose') {
            onCloseQueue.value.forEach((f) => f())
          }
        }
      })

      init.value = true
    }
  }

  const onClose = (callback: () => void) => {
    onCloseQueue.value.push(callback)
  }

  return { context: unref(context), xprops: unref(xprops), onClose }
}
